import i18next from 'i18next';
import React from 'react';
import { useSelector } from 'react-redux';

import GuarantorInfoModal from '~app/components/GuarantorInfoModal';
import { useModal } from '~app/hooks/useModal';
import { ReactComponent as Guarantor } from '~assets/guarantor.svg';
import { MODALS } from '~redux/Modal/constants';

import styles from './styles.module.scss';

// Context for credits with a guarantor, shown before the evaluation choices
// instead of a banner attached to them.
function GuarantorNotice() {
  const needsGuarantor = useSelector(state => state.simulation.needsGuarantor);
  const { handleOpenModal } = useModal();
  if (!needsGuarantor) {
    return null;
  }

  return (
    <div className={styles.notice}>
      <span className={styles.iconContainer}>
        <Guarantor className={styles.noticeIcon} aria-hidden="true" />
      </span>
      <span className={styles.noticeTexts}>
        <span className={styles.noticeTitle}>{i18next.t('ClientFlowChoice:guarantorTitle')}</span>
        <span className={styles.noticeDetail}>{i18next.t('ClientFlowChoice:guarantorDetail')}</span>
        <button type="button" className={styles.noticeLink} onClick={handleOpenModal(MODALS.GUARANTOR_INFO)}>
          {i18next.t('ClientFlowChoice:guarantorLink')}
        </button>
      </span>
      <GuarantorInfoModal />
    </div>
  );
}

export default GuarantorNotice;
